import React from "react";
import { Grid } from "@mui/material";
import * as S from "./PregnantForms/styles";
import CompTextField from "components/CompTextField";
import CompDropdown from "components/CompDropdown";
import AgentType from "utils/agentType";

const Forms = ({
  isView,
  beneficiaryData = null,
  register,
  unregister,
  isEdit,
  errors,
}) => {
  const estados = [
    { value: "AL", textLabel: "AL" },
    { value: "PE", textLabel: "PE" },
    { value: "SE", textLabel: "SE" },
  ];

  const agent_type = AgentType();

  return (
    <S.Form>
      <Grid container spacing={2}>
        {/* Linha 1 */}
        <Grid item xs={12} sm={4} >
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.person?.family.street_type}
            textLabel="TIPO DE LOGRADOURO:"
            fromNis
            name="street_type"
            register={register}
            unregister={unregister}
            error={errors.street_type}
            helperText={errors.street_type?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.person?.family.street_name}
            textLabel="LOGRADOURO:"
            placeholder="Rua do Beneficiário"
            fromNis
            name="street_name"
            register={register}
            unregister={unregister}
            error={errors.street_name}
            helperText={errors.street_name?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4} >
          <CompTextField
            isView={isView}
            apiText={beneficiaryData?.person?.family.street_number}
            textLabel="NÚMERO:"
            placeholder="N°"
            fromNis
            name="street_number"
            register={register}
            unregister={unregister}
            error={errors.street_number}
            helperText={errors.street_number?.message}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CompTextField
            isView={isView}
            fromNis
            apiText={beneficiaryData?.person?.family.complement}
            textLabel="COMPLEMENTO:"
            name="complement"
            register={register}
            unregister={unregister}
            error={errors.complement}
            helperText={errors.complement?.message}
          />
        </Grid>

        {/* Linha 2 */}
        <Grid item xs={12} sm={3}>
          <CompTextField
            isView={isView}
            fromNis
            textLabel="BAIRRO:"
            apiText={beneficiaryData?.person?.family.name_location}
            name="name_location"
            register={register}
            unregister={unregister}
            error={errors.name_location}
            helperText={errors.name_location?.message}
          />
        </Grid>
        
        <Grid item xs={12} sm={3} >
          <CompTextField
            isView={isView}
            fromNis
            textLabel="MUNICÍPIO:"
            apiText={beneficiaryData?.person?.family.city}
            name="city"
            register={register}
            unregister={unregister}
            error={errors.city}
            helperText={errors.city?.message}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <CompTextField
            isView={isView}
            fromNis
            apiText={beneficiaryData?.person?.rg_uf}
            textLabel="UF:"
            name="rg_uf"
            register={register}
            unregister={unregister}
            error={errors.rg_uf}
            helperText={errors.rg_uf?.message}
          />
        </Grid>
        {/* Linha 3 */}
        <Grid item xs={12} sm={9}>
          <CompTextField
            isView={isView}
            fromNis
            textLabel="NOME DA UNIDADE DE SAÚDE DA FAMÍLIA (USF) / UNIDADE BÁSICA DE SAÚDE (UBS):"
            apiText={beneficiaryData?.ufs_ubs}
            required
            edit={isEdit}
            name="ufs_ubs"
            register={register}
            unregister={unregister}
            error={errors.ufs_ubs}
            helperText={errors.ufs_ubs?.message}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <CompTextField
            isView={isView}
            fromNis
            apiValue={beneficiaryData?.updated ? "Sim" : "Não"}
            textLabel="ATUALIZADO CADÚNICO?"
            name="updated"
            register={register}
            unregister={unregister}
            error={errors.updated}
            helperText={errors.updated?.message}
          />
        </Grid>
      </Grid>
    </S.Form>
  );
};

export default Forms;
